module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-frame",
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._l((_vm.sections), function(section) {
    return [(section.type === 'PROFILE') ? [_c('div', {
      staticClass: "block"
    }, [_c('div', {
      staticClass: "section-title",
      attrs: {
        "id": section.id
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(section.label)
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(section.text)
      }
    }), _vm._v(" "), (section.contact) ? _c('div', {
      staticClass: "contact"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(section.contact.text)
      }
    }), _vm._v(" "), _vm._l((section.contact.values), function(v, index) {
      return _c('span', {
        key: index
      }, [(v.url) ? _c('a', {
        domProps: {
          "innerHTML": _vm._s(v.picto)
        },
        on: {
          "click": function($event) {
            _vm.open(v.url)
          }
        }
      }) : (v.mail) ? _c('a', {
        attrs: {
          "href": 'mailto:' + v.mail
        },
        domProps: {
          "innerHTML": _vm._s(v.picto)
        }
      }) : _vm._e()])
    })], 2) : _vm._e()])] : (section.type === 'EXPERIENCE') ? [_c('div', {
      staticClass: "block"
    }, [_c('div', {
      staticClass: "section-title",
      attrs: {
        "id": section.id
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(section.label)
      }
    })])]), _vm._v(" "), _c('transition-group', {
      staticClass: "blocks-container",
      attrs: {
        "name": "list-complete",
        "tag": "div"
      }
    }, _vm._l((_vm.getMissions(section)), function(m, index) {
      return _c('div', {
        key: index,
        staticClass: "block exp list-complete-item",
        attrs: {
          "id": 'm' + (index + 1)
        }
      }, [_c('div', {
        staticClass: "logo"
      }, [_c('img', {
        attrs: {
          "src": _vm.asset(m.logo)
        }
      }), _c('span', {
        staticClass: "title",
        domProps: {
          "innerHTML": _vm._s(m.title)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(m.from) + " "), (m.to) ? [_vm._v(" - " + _vm._s(m.to))] : _vm._e()], 2), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_c('p', [_c('span', {
        domProps: {
          "innerHTML": _vm._s(m.text)
        }
      }), _vm._v(" "), (m.tasks && m.tasks.length > 0) ? _c('ul', _vm._l((m.tasks), function(t, index) {
        return _c('li', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(t)
          }
        })])
      })) : _vm._e()])]), _vm._v(" "), (m.badges && m.badges.length > 0) ? _c('div', {
        staticClass: "badges"
      }, _vm._l((m.badges), function(b, index) {
        return _c('div', {
          staticClass: "badge"
        }, [_vm._v(_vm._s(b))])
      })) : _vm._e()])
    })), _vm._v(" "), _c('div', {
      staticClass: "block show-more"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.seeMoreLabel)
      },
      on: {
        "click": _vm.showMore
      }
    })])] : (section.type === 'SKILLS') ? [_c('div', {
      staticClass: "block"
    }, [_c('div', {
      staticClass: "section-title",
      attrs: {
        "id": section.id
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(section.label)
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "skills-container"
    }, _vm._l((section.back), function(s, index) {
      return _c('div', {
        key: index,
        staticClass: "skills"
      }, [_c('img', {
        attrs: {
          "src": _vm.asset(s)
        }
      })])
    })), _vm._v(" "), _c('div', {
      staticClass: "skills-container"
    }, _vm._l((section.front), function(s, index) {
      return _c('div', {
        key: index,
        staticClass: "skills"
      }, [_c('img', {
        attrs: {
          "src": _vm.asset(s)
        }
      })])
    })), _vm._v(" "), _c('div', {
      staticClass: "skills-container"
    }, _vm._l((section.langs), function(s, index) {
      return _c('div', {
        key: index,
        staticClass: "skills"
      }, [_c('img', {
        attrs: {
          "src": _vm.asset(s)
        }
      })])
    }))])] : (section.type === 'EDUCATIONS') ? [_c('div', {
      staticClass: "block"
    }, [_c('div', {
      staticClass: "section-title",
      attrs: {
        "id": section.id
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(section.label)
      }
    })])]), _vm._v(" "), _vm._l((section.educations), function(e, index) {
      return _c('div', {
        key: index,
        staticClass: "block edu"
      }, [_c('div', {
        staticClass: "logo"
      }, [_c('img', {
        attrs: {
          "src": _vm.asset(e.logo)
        }
      }), _c('span', {
        staticClass: "title",
        domProps: {
          "innerHTML": _vm._s(e.title)
        }
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(e.year))]), _c('span', [_vm._v(_vm._s(e.text))])])])
    })] : _vm._e()]
  }), _vm._v(" "), (_vm.links && _vm.links.length > 0) ? _c('div', {
    staticClass: "block links"
  }, [_vm._l((_vm.links), function(l, index) {
    return [(l.url) ? _c('span', {
      key: index,
      staticClass: "link",
      domProps: {
        "innerHTML": _vm._s(l.picto)
      },
      on: {
        "click": function($event) {
          _vm.open(l.url)
        }
      }
    }) : (l.mail) ? _c('a', {
      key: index,
      staticClass: "link",
      attrs: {
        "href": 'mailto:' + l.mail
      },
      domProps: {
        "innerHTML": _vm._s(l.picto)
      },
      on: {
        "click": function($event) {
          _vm.open(l.url)
        }
      }
    }) : _vm._e()]
  })], 2) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a4e21ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Body.vue
// module id = 48
// module chunks = 0